import TagManager from "react-gtm-module";
import { buildMode } from "../../../common/environment";


export interface IOrderTrackingInfo {
  order_id: string,
  total: number,
  voucher_code: string,
  phone_number?: string
}
export interface IOrderTracking {
  orderInfo: IOrderTrackingInfo,
  products: IProductTrackingInfo[]
}

export interface IProductTrackingInfo {
  name: string,
  id: string,
  price: number,
  category: string,
  variant?: string,
  quantity: number,
  promotion?: string,
  discount_price?: number,
  unit_price?: number,
  subtotal_amount?: number,
}

export enum ECheckoutType {
  SHIPPING_INFO = "SHIPPING_INFO",
  PAYMENT_METHOD = "PAYMENT_METHOD"
}

export const initGTM = () => {
  let gtmId = "GTM-PXF96G9";
  if (buildMode === "production") {
    gtmId = "GTM-WVNND5C";
  }

  TagManager.initialize({
    gtmId: gtmId,
  });
};


const clearDataLayer = () => {
  try {
    eval(`let dataLayer = window?.dataLayer
  if (dataLayer) {
    dataLayer.push({ ecommerce: null });
  }`)

  } catch { }
}

export const trackingViewDetailProduct = (product: IProductTrackingInfo) => {
  clearDataLayer()
  const data = {
    'event': 'productViewDetail',
    'ecommerce': {
      'detail': {
        'actionField': { 'list': product.category },
        'products': [{
          'name': product.name,
          'id': product.id,
          'retail_price': product.price,
          'price': product.unit_price,
          'category': product.category,
          'promotion': product.promotion,
          'discount_price': product.discount_price,
          'variant': product.variant,
          'brand': 'Kymdan',
        }]
      }
    }
  }
  console.log("tracking", data)
  TagManager.dataLayer({
    dataLayer: data,
  })
  clearDataLayer()
  const dataGA4 = {
    'event': 'view_item',
    'ecommerce': {
      currency: "VND",
      value: product.unit_price ? product.unit_price : product.price,
      items: [
        {
          item_id: product.id,
          item_name: product.name,
          currency: "VND",
          discount: product.unit_price ? product.price - product.unit_price : 0,
          index: 0,
          item_brand: "Kymdan",
          item_category: product.category,
          item_variant: product.variant,
          price: product.unit_price ? product.unit_price : product.price,
          quantity: 1
        }
      ]
    }
  }

  console.log("tracking GA4", dataGA4)
  TagManager.dataLayer({
    dataLayer: dataGA4,
  })
}

export const trackingProductClick = (product: IProductTrackingInfo) => {
  clearDataLayer()
  const data = {
    'event': 'productClick',
    'ecommerce': {
      'click': {
        'products': [{
          'name': product.name,
          'id': product.id,
          'retail_price': product.price,
          'price': product.unit_price,
          'category': product.category,
          'promotion': product.promotion,
          'discount_price': product.discount_price,
          'variant': product.variant,
          'brand': 'Kymdan',
        }]
      }
    }
  }
  console.log("tracking", data)
  TagManager.dataLayer({
    dataLayer: data,
  })
}


export const addProductToCart = (products: IProductTrackingInfo[]) => {
  clearDataLayer()
  const data = {
    'event': 'addToCart',
    'ecommerce': {
      'currencyCode': 'VND',
      'add': {
        'products': products.map(product => {
          return {
            'name': product.name,
            'id': product.id,
            'retail_price': product.price,
            'price': product.unit_price,
            'category': product.category,
            'promotion': product.promotion,
            'quantity': product.quantity,
            'subtotal_amount': product.subtotal_amount,
            variant: product.variant,
            'brand': 'Kymdan',
          }
        })
      }
    }
  }

  console.log("tracking", data)
  TagManager.dataLayer({
    dataLayer: data,
  })
  const items = products.map((product, index) => {
    return {
      item_id: product.id,
      item_name: product.name,
      currency: "VND",
      discount: product.unit_price ? product.price - product.unit_price : 0,
      index: index,
      item_brand: "Kymdan",
      item_category: product.category,
      item_variant: product.variant,
      retail_price: product.price,
      price: product.unit_price,
      quantity: product.quantity
    }
  })


  clearDataLayer()
  const dataGA4 = {
    'event': 'add_to_cart',
    'ecommerce': {
      currency: "VND",
      value: items.reduce((prev, item) => {
        prev += (item.price ? item.price : item.retail_price) * item.quantity
        return prev
      }, 0),
      items: items
    }
  }
  console.log("tracking GA4", dataGA4)
  TagManager.dataLayer({
    dataLayer: dataGA4,
  })
}

export const removeProductToCart = (products: IProductTrackingInfo[]) => {
  clearDataLayer()
  const data = {
    'event': 'removeFromCart',
    'ecommerce': {
      'currencyCode': 'VND',
      'remove': {
        'products': products.map(product => {
          return {
            'name': product.name,
            'id': product.id,
            'retail_price': product.price,
            'price': product.unit_price,
            'category': product.category,
            'promotion': product.promotion,
            'quantity': product.quantity,
            'subtotal_amount': product.subtotal_amount,
            variant: product.variant,
            'brand': 'Kymdan',
          }
        })
      }
    }
  }

  console.log("tracking", data)
  TagManager.dataLayer({
    dataLayer: data,
  })

  const items = products.map((product, index) => {
    return {
      item_id: product.id,
      item_name: product.name,
      currency: "VND",
      discount: product.unit_price ? product.price - product.unit_price : 0,
      index: index,
      item_brand: "Kymdan",
      item_category: product.category,
      item_variant: product.variant,
      retail_price: product.price,
      price: product.unit_price,
      quantity: product.quantity
    }
  })


  clearDataLayer()
  const dataGA4 = {
    'event': 'remove_from_cart',
    'ecommerce': {
      currency: "VND",
      value: items.reduce((prev, item) => {
        prev += (item.price ? item.price : item.retail_price) * item.quantity
        return prev
      }, 0),
      items: items
    }
  }
  console.log("tracking GA4", dataGA4)
  TagManager.dataLayer({
    dataLayer: dataGA4,
  })
}


export const checkout = (step: ECheckoutType, products: IProductTrackingInfo[], total: number, option: any = null) => {
  clearDataLayer()
  const items = products.map((product, index) => {
    return {
      item_id: product.id,
      item_name: product.name,
      currency: "VND",
      discount: product.unit_price ? product.price - product.unit_price : 0,
      index: index,
      item_brand: "Kymdan",
      item_category: product.category,
      item_variant: product.variant,
      retail_price: product.price,
      price: product.unit_price,
      quantity: product.quantity
    }
  })

  let eventName = 'checkoutStepShippingInfo'
  if (step == ECheckoutType.PAYMENT_METHOD) {
    eventName = 'checkoutStepPaymentMethod'
  }
  const data = {
    'event': eventName,
    'ecommerce': {
      'currencyCode': 'VND',
      'checkout': {
        'actionField': { 'step': step, 'option': option, total: total },
        'products': products.map(product => {
          return {
            'name': product.name,
            'id': product.id,
            'retail_price': product.price,
            'price': product.unit_price,
            'category': product.category,
            'promotion': product.promotion,
            'quantity': product.quantity,
            'subtotal_amount': product.subtotal_amount,
            variant: product.variant,
            'brand': 'Kymdan',
          }
        })
      }
    }
  }

  console.log("tracking", data)
  TagManager.dataLayer({
    dataLayer: data,
  })

  if (step == ECheckoutType.SHIPPING_INFO) {
    clearDataLayer()
    const dataGA4 = {
      'event': 'add_shipping_info',
      'ecommerce': {
        currency: "VND",
        value: items.reduce((prev, item) => {
          prev += (item.price ? item.price : item.retail_price) * item.quantity
          return prev
        }, 0),
        items: items
      }
    }
    console.log("tracking GA4", dataGA4)
    TagManager.dataLayer({
      dataLayer: dataGA4,
    })
  } else if (step == ECheckoutType.PAYMENT_METHOD) {
    clearDataLayer()
    const dataGA4addPaymentInfo = {
      'event': 'add_payment_info',
      'ecommerce': {
        currency: "VND",
        value: items.reduce((prev, item) => {
          prev += (item.price ? item.price : item.retail_price) * item.quantity
          return prev
        }, 0),
        payment_type: option?.payment_method,
        items: items
      }
    }

    console.log("tracking GA4", dataGA4addPaymentInfo)
    TagManager.dataLayer({
      dataLayer: dataGA4addPaymentInfo,
    })
  }
}

export const beginCheckout = (products: IProductTrackingInfo[]) => {
  clearDataLayer()
  const items = products.map((product, index) => {
    return {
      item_id: product.id,
      item_name: product.name,
      currency: "VND",
      discount: product.unit_price ? product.price - product.unit_price : 0,
      index: index,
      item_brand: "Kymdan",
      item_category: product.category,
      item_variant: product.variant,
      retail_price: product.price,
      price: product.unit_price,
      quantity: product.quantity
    }
  })

  const dataGA4 = {
    'event': 'begin_checkout',
    'ecommerce': {
      currency: "VND",
      value: items.reduce((prev, item) => {
        prev += (item.price ? item.price : item.retail_price) * item.quantity
        return prev
      }, 0),
      items: items
    }
  }
  console.log("tracking GA4", dataGA4)
  TagManager.dataLayer({
    dataLayer: dataGA4,
  })
}

export const trackingViewCart = (products: IProductTrackingInfo[]) => {
  clearDataLayer()
  const items = products.map((product, index) => {
    return {
      item_id: product.id,
      item_name: product.name,
      currency: "VND",
      discount: product.unit_price ? product.price - product.unit_price : 0,
      index: index,
      item_brand: "Kymdan",
      item_category: product.category,
      item_variant: product.variant,
      retail_price: product.price,
      price: product.unit_price,
      quantity: product.quantity
    }
  })

  const dataGA4 = {
    'event': 'view_cart',
    'ecommerce': {
      currency: "VND",
      value: items.reduce((prev, item) => {
        prev += (item.price ? item.price : item.retail_price) * item.quantity
        return prev
      }, 0),
      items: items
    }
  }
  console.log("tracking GA4", dataGA4)
  TagManager.dataLayer({
    dataLayer: dataGA4,
  })
}


export const purchasesOrder = (orderInfo: any, products: IProductTrackingInfo[]) => {
  clearDataLayer()
  const items = products.map((product, index) => {
    return {
      item_id: product.id,
      item_name: product.name,
      currency: "VND",
      discount: product.unit_price ? product.price - product.unit_price : 0,
      index: index,
      item_brand: "Kymdan",
      item_category: product.category,
      item_variant: product.variant,
      retail_price: product.price,
      price: product.unit_price,
      quantity: product.quantity
    }
  })


  const dataGA4 = {
    'event': 'purchase',
    'ecommerce': {
      transaction_id: orderInfo.order_id,
      currency: "VND",
      value: orderInfo.total,
      coupon: orderInfo.voucher_code,
      phone_number: orderInfo.phone_number,
      items: items
    }
  }
  console.log("tracking GA4", dataGA4)
  TagManager.dataLayer({
    dataLayer: dataGA4,
  })
}

export const trackingEventDynamic = (event: string, options: any = null) => {
  const data = {
    event: event,
    ...options
  }
  console.log("tracking", data)
  TagManager.dataLayer({
    dataLayer: data,
  })
}
